import { render, staticRenderFns } from "./ReportingActionsRemindUserModal.vue?vue&type=template&id=71939064&"
import script from "./ReportingActionsRemindUserModal.vue?vue&type=script&lang=js&"
export * from "./ReportingActionsRemindUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports